<template>
    <div ref="StackedLineMain" class="card card-iphone" :style="style">
      <div class="card-header bg-gray-light border-0 pb-1" ref="headerChart">
        <h3 class="card-title font-weight-bolder">
          <i class="fas fa-th mr-1"></i>
          <v-tooltip top>
            <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ title }}</span>
            <template v-slot:activator="{ on }">
              <span style="font-weight: 600;" v-if="title !== undefined && title !== null && title.length > 50">...</span>
              <span style="font-weight: 600;"
                    v-on="on">{{ (title !== undefined && title !== null) ? title.slice(0, 50) : "" }}</span>
            </template>
          </v-tooltip>
        </h3>
        <div v-if="(!isFrameSetting)" class="card-tools mb-2 ml-auto">
          <button v-if="isShowEdit" type="button" class="btn btn-sm" @click="clickClose">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <v-layout column style="overflow: auto">
        <v-flex md6 grow style="overflow: auto; height: 100%;">
          <div class="container col-xl-12 col-lg-12 col-12">
            <div class="content">
              <div class="grid">
                  <div
                      class="grid-item"
                      v-for="(data, index) in itemsList"
                      :key="index"
                      >
                      <a :href="data.urlName" style="color: black; text-decoration: underline;" target="_blank" rel="noopener noreferrer">
                        <v-tooltip top>
                          <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ data.frameName }}</span>
                          <template v-slot:activator="{ on }">
                            <span class="filename"
                              v-on="on">{{ data.frameName ? data.frameName.slice(0, 15) : "" }}{{ data.frameName && data.frameName.length > 15 ? "..." : "" }}
                            </span>
                          </template>
                        </v-tooltip>
                      </a>
                  </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
      
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
    </div>
  </template>

<script>
  export default {
    name: "S3F",
    props: {
      height: Number,
      width: Number,
      title: String,
      link: String,
      isFrameSetting: Boolean,
      isShowEdit: Boolean,
      frameId: Number,
      listTable: Array,
    },
    data() {
      return {
        ERROR_CODE : "",
        heightReal: null,
        loading: false,
        selectedFolder: "",
        OV: undefined,
        itemsList: [],
      }
    },
    computed: {
      style() {
        // eslint-disable-next-line
        this.heightReal = this.height;
        return "height: " + this.heightReal + "px";
      },
    },
    created() {
        this.itemsList = this.listTable.map((item, index) => {
            return {
                index: index,
                frameName: item.displayName,
                urlName: item.linkUrl,
            };
        });
    },
    async beforeMount() {
      // ========================================================== start import ERROR_CODE by language
      // ==============================================================================================
      const currentLang = this.$i18n.locale
      await import(`@/utils/errors/dashboard/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/dashboard/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
      // ==============================================================================================
      // =========================================================== stop import ERROR_CODE by language
    },
    methods: {
      clickClose() {
        this.$emit(`closeFrame`, this.frameId);
      },
    },
    destroyed() {
    },
    watch: {
      '$i18n.locale': async function (currentLang) {
        // ========================================================== start import ERROR_CODE by language
        // ==============================================================================================
        await import(`@/utils/errors/dashboard/${currentLang}.js`)
          .then((DATA) => {
            this.ERROR_CODE = DATA.ERROR_CODE
          })
          .catch(async () => {
            await import(`@/utils/errors/dashboard/${currentLang}.js`)
              .then((DATA) => {
                this.ERROR_CODE = DATA.ERROR_CODE
              })
          })
        // ==============================================================================================
        // =========================================================== stop import ERROR_CODE by language
      },
      listTable: {
            handler(newListTable) {
                this.itemsList = newListTable.map((item, index) => ({
                    index: index,
                    frameName: item.displayName,
                    urlName: item.linkUrl,
                }));
            },
            deep: true,
            immediate: true, 
        },
    }
  }
</script>
  
<style scoped lang="scss">
    
    @media (max-width: 991px) {
      [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
        margin-top: 6rem !important;
      }
    }
    @media (min-width: 992px) and (max-width: 1400px){
      [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
        margin-top: 0rem !important;
      }
    }

    .container {
      display: flex !important;
      height: auto;
      width: 100% !important;
    }

    .sidebar {
      width: 20%;
      background: #f4f4f4;
      padding: 0px 10px;
      border-right: 1px solid #ddd;
      overflow-y: auto; 
      height: 420px;
    }

    .sidebar  ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .content {
      flex: 1;
      padding: 0px 20px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 420px;
    }

    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 20px;
      width: 100%;
    }

    .grid-item {
      text-align: center;
      background: white;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s;
    }

    .grid-item:hover {
        transform: scale(1.05);
    }

    .image {
        width: 100%;
        height: 150px;
        object-fit: cover;
        border-radius: 3px;
    }

    .filename {
        margin-top: 5px;
        font-size: 14px;
        color: #333;
        word-break: break-all;
        font-weight: bold;
    }
</style>
  